import {axiosNodeClient} from "../http";

export const messagePresetsServiceNode = {
    get,
    create,
    update,
    updateStatus,
    updateActive,
    del
}

function get(id) {
    if (id && Number(id) > 0) {
        return axiosNodeClient.get(`/message/presets/${id}`);
    } else {
        return axiosNodeClient.get(`/message/presets`);
    }
}

/*function getWelcome(step) {
    return axiosNodeClient.get(`/message/presets`, {
        params: {
            filter: 'welcome',
            step: step
        }
    });
}*/


function create(body) {
    return axiosNodeClient.post('/message/presets', body);
}


function update(body) {
    return axiosNodeClient.put(`/message/presets/${body.id}`, body);
}


function updateStatus(status, id) {
    return axiosNodeClient.put(`/message/presets/${id}/status`, {
        status: status
    });
}

function updateActive(active, id) {
    return axiosNodeClient.put(`/message/presets/${id}/active`, {
        active: active
    });
}

function del(id) {
    return axiosNodeClient.delete(`/message/presets/${id}`);
}
